import { find } from 'lodash';

class PropertySelectorController {
    constructor($rootScope, $window, $location, encryptService, propertiesService, properties, configService, storeService, access, currentPropertyService) {
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$location = $location;
        this.propertiesService = propertiesService;
        this.encryptService = encryptService;
        this.configService = configService;
        this.propertylist = properties.list;
        this.storeService = storeService;
        this.access = access;
        this.currentPropertyService = currentPropertyService;
    }

    $onInit () {
        this.saving = false;
        this.property = this.currentPropertyService.get();
    }

    onSelect (property) {
        this.saving = true;
        return this.encryptService.encrypt(property.id.toString()).then(encrypted => {
            this.storeService.set('property', encrypted.data);

            return this.propertiesService.findById(property.id).then(response => {
                this.$rootScope.currentProperty = response;

                this.storeService.remove('basket');

                let path = this.$location.path().split('/');
                if (path.length > 2 && parseInt(path[path.length - 2]) > 0) {
                    path.splice(-2);
                    this.$window.location.href = path.join('/');
                }
                else if (path.includes('page-content') && path.length > 3) {
                    path.splice(-1);
                    this.$window.location.href = path.join('/');
                }
                else {
                    this.$window.location.reload();
                }
            });
        });
    }
}

PropertySelectorController.$inject = ['$rootScope', '$window', '$location', 'encryptService', 'propertiesService', 'properties', 'configService', 'storeService', 'access', 'currentPropertyService'];

export default PropertySelectorController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.selector.controller.js